import { StyleSheet, Text, View } from '@react-pdf/renderer'
import { currencyFormatedString } from 'app/views/common/Formats'
import { PdfSplittableTableRow } from 'app/views/forms/pdf-components/PdfSplittableTableRow'
import { PdfTableCell } from 'app/views/forms/pdf-components/PdfTableCell'
import { PdfTableHeaderCell } from 'app/views/forms/pdf-components/PdfTableHeaderCell'
import { pdfTableBoldTextStyle, pdfTableStyles } from 'app/views/forms/pdf-components/PdfTableStyles'
import { PdfUnsplittableTableRow } from 'app/views/forms/pdf-components/PdfUnsplittableTableRow'
import { myI18n } from 'translation/I18nConnectedProvider'
import {
  BUDGET_EXPENSES_LINES_IN_ORDER,
  BUDGET_REVENUES_LINES_IN_ORDER
} from '../budget/FormBudgetUtils'

const styles = StyleSheet.create({
  firstCol: {
    width: '20%'
  },
  secondCol: {
    width: '12%'
  },
  thirdCol: {
    width: '28%'
  },
  fourthCol: {
    width: '12%'
  },
  fifthCol: {
    width: '28%'
  },
  fullWidthCol: {
    width: '100%'
  }
})

export const FormBudgetUpdatePDF = ({
  id,
  langVersion,
  useMultiuser,
  muBag,
  title,
  connectedObject,
  editMode,
  typeProps,
  i18n,
  disabled,
  helpText,
  value,
  ...props
}) => {
  const { expensesLines = {}, revenuesLines = {} } = value

  const getLineValues = (obj) => {
    const { budgetUpdateChange, budgetUpdateActual, applicationBudget, latestUpdate } = obj
    return {
      change: budgetUpdateChange?.change || latestUpdate?.change || applicationBudget.value,
      actual: budgetUpdateActual?.actual,
      changeComments: budgetUpdateChange?.changeDetails || '',
      actualComments: budgetUpdateActual?.actualComments || ''
    }
  }

  const sumLines = (lines) => {
    let sum = 0
    let sumActual = 0
    Object.values(lines).forEach((obj) => {
      const { change, actual } = getLineValues(obj)
      if (change) {
        sum += +change
      }
      if (actual) {
        sumActual += +actual
      }
    })
    return [sum, sumActual]
  }

  const [revenuesSum, revenuesSumActual] = sumLines(revenuesLines)
  const [expensesSum, expensesSumActual] = sumLines(expensesLines)

  const renderSectionTitle = (label) => (
    <PdfUnsplittableTableRow>
      <PdfTableCell style={styles.fullWidthCol}>
        <Text style={pdfTableBoldTextStyle}>{label}</Text>
      </PdfTableCell>
    </PdfUnsplittableTableRow>
  )

  const renderLines = (lines, order) =>
    Object.entries(lines)
      .sort((a, b) => order.indexOf(a) - order.indexOf(b))
      .map(([key, item]) => {
        const { change, actual, changeComments, actualComments } = getLineValues(item)
        return (
          <PdfSplittableTableRow key={key}>
            <PdfTableCell style={styles.firstCol}>
              <Text>{myI18n._(key)}</Text>
            </PdfTableCell>
            <PdfTableCell style={styles.secondCol}>
              <Text>{currencyFormatedString(change, langVersion)}</Text>
            </PdfTableCell>
            <PdfTableCell style={styles.thirdCol}>
              <Text>{changeComments}</Text>
            </PdfTableCell>
            <PdfTableCell style={styles.fourthCol}>
              <Text>{currencyFormatedString(actual, langVersion)}</Text>
            </PdfTableCell>
            <PdfTableCell style={styles.fifthCol}>
              <Text>{actualComments}</Text>
            </PdfTableCell>
          </PdfSplittableTableRow>
        )
      })

  const renderSum = (label, sum, sumActual) => (
    <PdfUnsplittableTableRow>
      <PdfTableCell style={styles.firstCol}>
        <Text style={pdfTableBoldTextStyle}>{label}</Text>
      </PdfTableCell>
      <PdfTableCell style={styles.secondCol}>
        <Text style={pdfTableBoldTextStyle}>{currencyFormatedString(sum, langVersion)}</Text>
      </PdfTableCell>
      <PdfTableCell style={styles.thirdCol} />
      <PdfTableCell style={styles.fourthCol}>
        <Text style={pdfTableBoldTextStyle}>{currencyFormatedString(sumActual, langVersion)}</Text>
      </PdfTableCell>
      <PdfTableCell style={styles.fifthCol} />
    </PdfUnsplittableTableRow>
  )

  return (
    <View style={pdfTableStyles.table}>
      <PdfUnsplittableTableRow>
        <PdfTableHeaderCell style={styles.firstCol} />
        <PdfTableHeaderCell
          headerConfig={typeProps}
          style={styles.secondCol}
        >
          {myI18n.t?.('Amount')}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell headerConfig={typeProps} style={styles.thirdCol}>
          {myI18n.t?.('BUDGET_UPDATE_CHANGES_COMMENTS_LABEL')}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell
          headerConfig={typeProps}
          style={styles.fourthCol}
        >
          {myI18n.t?.('BUDGET_UPDATE_ACTUAL')}
        </PdfTableHeaderCell>
        <PdfTableHeaderCell headerConfig={typeProps} style={styles.fifthCol}>
          {myI18n.t?.('BUDGET_UPDATE_ACTUAL_COMMENTS_LABEL')}
        </PdfTableHeaderCell>
      </PdfUnsplittableTableRow>

      {renderSectionTitle(myI18n.t?.('Revenues'))}
      {renderLines(revenuesLines, BUDGET_REVENUES_LINES_IN_ORDER)}

      {renderSectionTitle(myI18n.t?.('Expenses'))}
      {renderLines(expensesLines, BUDGET_EXPENSES_LINES_IN_ORDER)}

      {renderSum(myI18n.t?.('SUM_OF_REVENUES'), revenuesSum, revenuesSumActual)}
      {renderSum(myI18n.t?.('SUM_OF_EXPENSES'), expensesSum, expensesSumActual)}
    </View>
  )
}
